$gridElementsHeight: 52px;

:host {
  position: relative;
}

:host {
  --grid-row-height: 40px;
  --grid-row-background-color: transparent;
  --grid-row-background-color-alternate: var(--chart-050-hover);
  --grid-row-hover-background: var(--chart-104-pressed);
  --grid-row-selected-background: var(--blue-layout-051-selected);
  --grid-row-reordering-background: var(--white-layout-301-level-0-elevation);
  --grid-border-color: var(--chart-101-pressed-dividers);
  --grid-border-width: 1px;
  --checkbox-border-overflow: transparent;
  --checkbox-border-overfow-width: 0px;
  --icon-visibility: hidden;
  --grid-footer-height: 40px;
  --grid-pagination-height: 40px;
}

.wrapper {
  display: flex;
  flex-direction: column;
  background: transparent;
}

.grid {
  border-top: var(--grid-border-width) solid var(--grid-border-color);
  height: var(--grid-height, 100%);
  min-height: var(--grid-min-height, unset);
  max-height: var(--grid-max-height, unset);
  background-color: transparent;
}

vaadin-grid-column,
vaadin-grid-cell-content {
  font-size: var(--body-size-medium);
  font-family: var(--font-family-secondary) !important;
}

.wrapper {
  &.more-items-loading {
    .data-loader {
      display: flex;
    }
  }

  &.is-loading {
    .columns-loader {
      display: flex;
    }

    .counter-loader, // remove
    .rows-loader {
      display: block;
    }

    .grid-filters {
      display: none;
    }
  }

  &.is-error {
    .grid {
      // Show only the grid header (i.e., columns) in case of errors
      height: 47px;
    }

    .grid-wrapper {
      display: flex;
      flex-direction: column;
    }

    .data-loading-error {
      display: block;
    }
  }

  &.is-empty {
    .grid {
      // Show only the grid header (i.e., columns) in case of empty data
      min-height: var(--empty-grid-min-height, 400px);
      max-height: var(--empty-grid-max-height, 100%);
    }

    .grid-wrapper {
      display: flex;
      flex-direction: column;
    }

    .footer-wrapper {
      display: none;
    }

    .toolbar-actions__refresh {
      display: revert;
    }

    .no-results {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 0;
      right: 0;

      gz-image-repo {
        height: auto;
      }

      .no-results-additional-data {
        text-align: center;
      }
    }
  }

  .sorting-icon {
    margin: auto;
    height: 19px;
    font-size: 19px;
    line-height: 17px;
    vertical-align: bottom;
  }
}

.no-results,
.data-loading-error {
  display: none;
  width: 500px;
  height: calc(100% - 65px);
  flex-grow: 1;
  margin: auto;
  pointer-events: none;

  gz-text {
    line-height: 1.15;
  }

  ::slotted(*) {
    pointer-events: var(--grid-slot-pointer-events, all);
  }
}

.wrapper {
  &.grid-is-compact {
    .data-loading-error {
      height: calc(100% + 10px);
    }

    .no-results {
      height: calc(100% - 15px);
    }
  }
}

.grid-header__toolbar {
  padding: var(--spacer) calc(var(--spacer) * 2.5);
}

.grid-header__toolbar {
  display: flex;
  align-items: center;

  &.is-disabled {
    opacity: 0.3 !important;

    .csv-export {
      pointer-events: none;
    }
  }
}

.grid-header-actions {
  display: flex;
  margin-left: auto;
  align-items: center;
}

.toolbar-actions__refresh {
  display: none;
}

.grid-header__title {
  width: initial;
}

.grid-header__global-actions {
  display: none;
  height: 52px;
  padding: calc(var(--spacer) * 1) calc(var(--spacer) * 2.5);
}

.grid-header__info-box {
  display: flex;
  max-height: 70px;
  min-height: 0;
  margin-left: var(--spacer);
}

.grid-header-actions__smart-view-actions {
  display: flex;
  align-items: center;
  line-height: 1;
  position: relative;
  margin-top: -2px;

  .action {
    position: relative;
    padding: 0 var(--spacer);
  }
}

#smartViewsActions {
  display: flex;
}

.grid-header-actions__toolbar-actions {
  display: flex;
  align-items: center;
  line-height: 1;
  position: relative;
  margin-left: var(--spacer);
  box-shadow: var(--chart-101-pressed-dividers) -3px 1px 0px -2px;

  & > * {
    margin-left: calc(2 * var(--spacer));
  }
}

.rows-loader {
  background-color: transparent;
  border-top: 1px solid var(--chart-101-pressed-dividers);
  position: absolute;
  z-index: 1000;
  width: 100%;
  height: 100%;
  top: 0;
  display: none;
  overflow: hidden;
}

.columns-loader {
  margin: 0 auto;
  width: 100%;
  padding: 0 calc(2 * var(--spacer));
  height: $gridElementsHeight;
  background-color: transparent;
  display: flex;
  align-items: center;
  display: none;

  gz-loader {
    width: 100%;
    height: 24px !important;
  }
}

.grid-wrapper {
  justify-content: space-evenly;
  position: relative;
  flex: 1;
}

.data-loader {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  padding: var(--spacer) 0;
  border-top: 1px solid var(--chart-101-pressed-dividers);
  background-color: transparent;
  left: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  display: none;
}

.filters-wrapper {
  border-top: var(--filter-grid-border, var(--grid-border-width) solid var(--grid-border-color));
  display: flex;
  align-items: center;
  position: relative;
  min-height: $gridElementsHeight;
}

.footer-wrapper {
  height: var(--grid-footer-height);
  border-top: 1px solid var(--grid-border-color);
  align-self: flex-end;
  margin-top: auto;
  width: 100%;
  background: transparent;
  position: relative;
}

vaadin-grid::part(reorder-ghost) {
  font-size: var(--body-size);
  background-color: var(--reorder-ghost-background);
}

vaadin-grid-column {
  color: var(--body-text-arrows-400);
}

vaadin-grid-cell-content {
  // https://developer.mozilla.org/en-US/docs/Web/CSS/::part
  vaadin-checkbox[checked]::part(checkbox) {
    background: var(--blue-layout-400-primary);
    border-color: var(--blue-layout-400-primary);
    &:after {
      transform: scale(1) rotate(-45deg);
    }
    &:hover {
      background: var(--blue-layout-303-active);
      border-color: transparent;
    }
    &:active {
      background: var(--blue-layout-400-primary);
      border-color: var(--blue-layout-400-primary);
    }
  }

  vaadin-checkbox[indeterminate]::part(checkbox) {
    &:after {
      transform: scale(1) rotate(0deg);
      border-left: transparent;
      height: 10%;
      top: 4px;
    }
  }

  vaadin-checkbox[disabled]::part(checkbox) {
    border-color: var(--grey-layout-202-disabled-icons);
  }

  vaadin-checkbox {
    margin-left: 0;
    display: flex;
    align-items: center;
  }

  vaadin-checkbox::part(checkbox) {
    width: 14px;
    height: 14px;
    margin: 0;
    border-radius: 2px;
    border: 2px solid;
    border-color: var(--chart-300-icon-buttons);
    background-color: transparent;
    transition: all 0.3s ease-in-out 0s;
    cursor: pointer;
    pointer-events: unset;
    &:before {
      content: '';
      transform: none;
      transition: none;
    }
    &:after {
      content: '';
      position: absolute;
      top: -4px;
      left: 2px;
      width: 10px;
      height: 5px;
      background: none;
      border: none;
      box-sizing: unset;
      border-bottom: 2px solid var(--white-layout-301-level-0-elevation);
      border-left: 2px solid var(--white-layout-301-level-0-elevation);
      transform: scale(0) rotate(-45deg);
      transform-origin: right bottom;
    }
    &:hover {
      border-color: var(--main-titles-inputs-602);
    }
  }
  &.details-toggle__cell-content {
    display: flex;
    justify-content: center;
    padding-left: var(--spacer);
    overflow: visible;
  }
}

vaadin-grid-cell-content {
  color: var(--body-text-arrows-400);
  line-height: initial;
  display: flex;
  align-items: center;
  height: 100%;

  [class*=' row-'] {
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
  }
  .column-editable {
    --font-family: var(--font-family-secondary);
    display: flex;
    font-size: var(--body-size-medium);

    gz-button::part(button-text) {
      --font-family: var(--font-family-secondary);
    }
  }
  gz-icon-button {
    height: auto;
  }
  gz-enum-filter {
    &:focus {
      outline: none;
    }
  }

  vaadin-grid-sorter {
    .cell-label {
      padding-top: 3px;
    }

    &[direction] {
      color: var(--body-text-arrows-400);
    }

    &:not([direction])::part(indicators):before {
      content: '\e91d';
    }

    &[direction='asc']::part(indicators):before {
      content: '\e91e';
    }

    &[direction='desc']::part(indicators):before {
      content: '\e91c';
    }

    &::part(indicators) {
      margin-left: 0;
      color: var(--chart-300-icon-buttons);
      border-radius: 4px;
      padding: 2px 0;

      &:hover {
        background-color: var(--grid-row-hover-background);
      }
    }

    &::part(indicators):before {
      font-family: 'ds-bitdefender';
      font-size: 22px;
      line-height: 0;
      transform: translateY(3px);
      opacity: 1;
    }

    &:not([direction])::part(indicators),
    &:not([direction])::part(indicators):before {
      visibility: var(--icon-visibility);
    }
  }
}

.cell-label {
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: var(--font-family-secondary);
  font-size: var(--body-size-medium);

  &--header {
    font-family: var(--font-family);
    font-size: var(--body-size);
  }
}

.full-height-cell {
  display: flex;
  align-items: center;
  height: 100%;
  overflow: hidden;
  pointer-events: all;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.grid-checkbox {
  width: 20px;
  height: 20px;
}

.csv-export {
  display: none;
}

:host([enableCSVExport]) {
  .csv-export {
    display: block;
  }
}

:host([hideGridRefresh]) {
  .grid-refresh {
    display: none;
  }
}

:host([showToolbarRefresh]) {
  .toolbar-actions__refresh {
    display: revert;
  }
}

:host([hideHeaderActions]) {
  .grid-header-actions {
    display: none;
  }
}

:host([disableGridSettings]) {
  .toggle-grid-settings {
    display: none;
  }
}

:host([hideFooter]) {
  .footer-wrapper {
    display: none;
  }
}

:host([removeFilters]) {
  .filters-wrapper,
  .toggle-grid-filters {
    display: none;
  }
}

:host([hideFiltersToggle][disableGridSettings]:not([showToolbarRefresh])) {
  .grid-header__toolbar {
    display: none;
  }
}

:host([showGlobalActions]) {
  .grid-header__global-actions {
    display: flex;
    align-items: center;
  }
}

:host([showInfoBox]) {
  .grid-header__info-box {
    display: flex;
    align-items: center;
  }
}

:host([dynamicHeight]) {
  --empty-grid-min-height: calc(64px + var(--grid-row-height));
  --empty-grid-max-height: calc(64px + var(--grid-row-height));
  --grid-min-height: 161px;

  .wrapper.is-error .grid {
    min-height: 47px;
  }
  .no-results,
  .data-loader {
    margin-top: var(--grid-row-height);
  }
}
